import React from "react";

// Team
const Team = ({ language }) => {
  return (
    <React.Fragment>
      <main className="team-page">
        <section className="hero">
          <div className="container">
            <h1>
              <span>\\</span> The Ultimate Team <span>//</span>
            </h1>

            <div className="team-members">
              <div className="team-member">
                <img
                  src="../../images/pages/team/team-member-img-1.webp"
                  alt=""
                />
                <h3>
                  {language === "english" ? (
                    <React.Fragment>CEO (Steve)</React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>CEO (스티브)</React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>首席执行官（史蒂夫)</React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>Giám đốc điều hành (Steve)</React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>الرئيس التنفيذي (ستيف)</React.Fragment>
                  ) : null}
                </h3>
                <p>
                  {language === "english" ? (
                    <React.Fragment>
                      Steve has two decades of experience in the Project of AI,
                      IT and Manufacture industry. He has experience in
                      implementing government projects in the field of the 4th
                      industrial revolution. In addition, he has an in-depth
                      knowledge of the cryptocurrency token economy.Currently,
                      under his supervision, marketing and promotion are in
                      progress.
                    </React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>
                      스티브는 AI, IT 및 제조 산업 프로젝트에서 20년의 경험을
                      가지고 있습니다. 4차 산업혁명 분야의 정부과제를 수행한
                      경험이 있습니다. 또한 암호화폐 토큰 이코노미에 대한 심도
                      있는 지식을 보유하고 있습니다. 현재 그의 감독하에 마케팅
                      및 프로모션이 진행 중입니다.
                    </React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>
                      Steve 在人工智能、IT
                      和制造行业的项目中拥有二十年的经验。他在第四次工业革命领域具有执行政府项目的经验。此外，他对加密货币通证经济有深入的了解。目前，在他的监督下，营销和推广正在进行中。
                    </React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>
                      Steve có hai thập kỷ kinh nghiệm trong Dự án về AI, CNTT
                      và ngành Sản xuất. Ông có kinh nghiệm thực hiện các dự án
                      của chính phủ trong lĩnh vực cách mạng công nghiệp lần thứ
                      4. Ngoài ra, anh ấy có kiến ​​thức chuyên sâu về nền kinh
                      tế mã thông báo tiền điện tử. Hiện tại, dưới sự giám sát
                      của anh ấy, hoạt động tiếp thị và quảng bá đang được tiến
                      hành.
                    </React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>
                      يتمتع ستيف بخبرة عقدين من الزمن في مشروع الذكاء الاصطناعي
                      وتكنولوجيا المعلومات والصناعة. لديه خبرة في تنفيذ المشاريع
                      الحكومية في مجال الثورة الصناعية الرابعة. بالإضافة إلى ذلك
                      ، لديه معرفة عميقة باقتصاد العملة المشفرة ، وفي الوقت
                      الحالي ، تحت إشرافه ، يجري التسويق والترويج
                    </React.Fragment>
                  ) : null}
                </p>
              </div>

              <div className="team-member">
                <img
                  src="../../images/pages/team/team-member-img-2.webp"
                  alt=""
                />
                <h3>
                  {language === "english" ? (
                    <React.Fragment>CTO (Leo)</React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>CTO(레오)</React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>首席技术官（狮子座</React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>CTO (Leo)</React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>CTO (ليو)</React.Fragment>
                  ) : null}
                </h3>
                <p>
                  {language === "english" ? (
                    <React.Fragment>
                      Leo has accumulated experience and capabilities through
                      various projects in the IT industry for about 20 years. He
                      is a full-stack expert in front-end and back-end. He has
                      experience in big data analysis and advertising design,
                      especially virtual real estate design and coding
                      experience.
                    </React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>
                      레오는 약 20년 동안 IT 업계에서 다양한 프로젝트를 통해
                      경험과 역량을 축적했습니다. 그는 프론트엔드와 백엔드의
                      풀스택 전문가입니다. 그는 빅 데이터 분석 및 광고 디자인,
                      특히 가상 부동산 디자인 및 코딩 경험이 있습니다.
                    </React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>
                      Leo通过IT行业的各种项目积累了约20年的经验和能力。他是前端和后端的全栈专家。具有大数据分析和广告设计经验，尤其是虚拟房地产设计和编码经验。
                    </React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>
                      Leo đã tích lũy kinh nghiệm và năng lực thông qua các dự
                      án khác nhau trong ngành CNTT trong khoảng 20 năm. Anh ấy
                      là một chuyên gia toàn diện về front-end và back-end. Ông
                      có kinh nghiệm về phân tích dữ liệu lớn và thiết kế quảng
                      cáo, đặc biệt là kinh nghiệm thiết kế và mã hóa bất động
                      sản ảo.
                    </React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>
                      اكتسبت Leo خبرة وقدرات متراكمة من خلال مشاريع مختلفة في
                      صناعة تكنولوجيا المعلومات لمدة 20 عامًا تقريبًا. إنه خبير
                      متكامل في الواجهة الأمامية والخلفية. لديه خبرة في تحليل
                      البيانات الضخمة وتصميم الإعلانات ، وخاصة تصميم العقارات
                      الافتراضية وتجربة الترميز.
                    </React.Fragment>
                  ) : null}
                </p>
              </div>

              <div className="team-member">
                <img
                  src="../../images/pages/team/team-member-img-3.webp"
                  alt=""
                />
                <h3>
                  {language === "english" ? (
                    <React.Fragment>CFO (Brian)</React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>CFO(브라이언)</React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>首席财务官（布莱恩</React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>Giám đốc tài chính (Brian)</React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>المدير المالي (بريان)</React.Fragment>
                  ) : null}
                </h3>
                <p>
                  {language === "english" ? (
                    <React.Fragment>
                      Brian is a financial accounting expert and has experience
                      in accounting for top-level cryptocurrency exchanges in
                      Asia. In addition, he has abundant investment experience
                      in the financial and defi fields.
                    </React.Fragment>
                  ) : language === "korean" ? (
                    <React.Fragment>
                      브라이언은 재무 회계 전문가이며 아시아 최고 수준의
                      암호화폐 거래소 회계 경험이 있습니다. 또한 금융 및 디파이
                      분야에서 풍부한 투자 경험을 보유하고 있습니다.
                    </React.Fragment>
                  ) : language === "chinese" ? (
                    <React.Fragment>
                      Brian
                      是一名财务会计专家，拥有亚洲顶级加密货币交易所的会计经验。此外，他在金融和defi领域拥有丰富的投资经验。
                    </React.Fragment>
                  ) : language === "vietnamese" ? (
                    <React.Fragment>
                      Brian là chuyên gia kế toán tài chính và có kinh nghiệm kế
                      toán cho các sàn giao dịch tiền điện tử cấp cao nhất ở
                      Châu Á. Ngoài ra, ông có nhiều kinh nghiệm đầu tư trong
                      lĩnh vực tài chính và tài chính.
                    </React.Fragment>
                  ) : language === "arabic" ? (
                    <React.Fragment>
                      برايان هو خبير محاسبة مالية ولديه خبرة في المحاسبة عن
                      عمليات تبادل العملات المشفرة عالية المستوى في آسيا.
                      بالإضافة إلى ذلك ، لديه خبرة استثمارية وفيرة في المجالات
                      المالية والصعبة.
                    </React.Fragment>
                  ) : null}
                </p>
              </div>
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default Team;
